import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { getSensors } from '@powdr/stores';

export const useSensor = (sensor, sensorLocation) => {
  if (!sensor && !sensorLocation) return null;

  const dispatch = useDispatch();
  const useSensorData = useSelector((state) => state.sensors);
  const { sensors } = useSensorData;
  const [sensorData, setSensorData] = useState();

  useEffect(() => {
    dispatch(getSensors());
  }, [dispatch]);

  useEffect(() => {
    // set sensor data by name
    if (sensors && sensors?.[sensor] && !sensorLocation) {
      setSensorData(sensors[sensor]);
    }

    // set sensor data by location
    if (sensors && sensorLocation) {
      setSensorData(
        Object.values(sensors).find((s) => s?.location === sensorLocation),
      );
    }
  }, [sensors, sensor, sensorLocation]);

  return sensorData;
};
